module.exports = __webpack_public_path__ + "img/icon-card.1f2537a8.png";